import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client';

const CANONICAL_JOB_MARKER_FIELDS = ['interviewQuestions', 'jobDescription', 'published'];

export const isCanonicalJobPayload = (object) => {
  if (object?.__typename !== 'Job') return false;
  return CANONICAL_JOB_MARKER_FIELDS.some(field => Object.prototype.hasOwnProperty.call(object, field));
};

export const dataIdFromObject = (object) => {
  if (object?.__typename === 'Job' && !isCanonicalJobPayload(object)) {
    return undefined;
  }
  return defaultDataIdFromObject(object);
};

const createApolloCache = () => new InMemoryCache({ dataIdFromObject });

export default createApolloCache;
